import React from 'react';
import { Reveal } from './Reveal';
const outcomes = [{
  icon: '🔥',
  title: 'Quemar grasa caminando',
  text: 'Activar tu metabolismo con el ritmo y la técnica correcta para convertir cada paso en resultados visibles'
}, {
  icon: '📅',
  title: 'Crear un hábito sostenible',
  text: 'Armar una rutina que puedas mantener en el tiempo sin depender de la motivación del momento'
}, {
  icon: '⚡',
  title: 'Recuperar tu energía',
  text: 'Sentirte con más vitalidad desde la primera semana, con menos cansancio y mejor estado de ánimo'
}, {
  icon: '🥗',
  title: 'Combinar caminata y nutrición',
  text: 'Potenciar tus resultados con hábitos simples de alimentación que se adaptan a tu vida real'
}, {
  icon: '📊',
  title: 'Medir tu progreso real',
  text: 'Saber exactamente cuánto avanzás y ajustar tu plan para no estancarte nunca más'
}, {
  icon: '🧠',
  title: 'Dominar tu mentalidad',
  text: 'Romper el ciclo de frustración y construir la confianza para llegar a tu meta definitivamente'
}];
export function Outcomes() {
  return <section className="w-full bg-white" data-id="element-133" data-mp="2xzg6b077gfeb">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-24" data-id="element-134" data-mp="2y0ht21xl2qbv">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="2t6dn9m020ocd">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-136" data-mp="2p6cwd1vrqkof">
            Al terminar este programa vas a poder...
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-137" data-mp="2k8bbqcip2dau">
          {outcomes.map((o, i) => <Reveal key={o.title} delay={i % 3 * 0.08} data-id="element-138" data-mp="2a8ub49iauplq" data-mpi={i}>
              <div className="h-full rounded-2xl border border-ink/10 bg-cream p-6 transition-shadow hover:shadow-lg" data-id="element-139" data-mp="2a9cerr7ak63o">
                <span className="text-3xl" data-id="element-140" data-mp="269brri64mml0">{o.icon}</span>
                <h3 className="mt-4 text-lg font-bold text-ink" data-id="element-141" data-mp="8gfuddrhrr6w">{o.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-142" data-mp="4fcguxwx278u">{o.text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}